import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = ({ disabled }: { disabled?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
  >
    <path
      fill={disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="m7.64 9.057-1.825.006a1 1 0 1 0 .006 2l3.64-.011a1.6 1.6 0 0 0 1.596-1.599l.004-3.632a1 1 0 0 0-2-.002l-.002 1.828-4.132-4.131A1 1 0 0 0 3.513 4.93l4.128 4.127ZM16.354 14.94l4.131 4.131a1 1 0 0 1-1.414 1.414l-4.127-4.127-.006 1.826a1 1 0 1 1-2-.006l.011-3.641a1.6 1.6 0 0 1 1.599-1.595l3.632-.004a1 1 0 0 1 .002 2l-1.828.002Z"
      clipRule="evenodd"
    />
  </svg>
)

export default SvgComponent
